/****************************************************

Custom Button Animations

****************************************************/
jQuery(function( $ ) {
    // Nina button style
    $( '.btn-nina').each( function() {

        let $thisButton = $( this ),
            buttonNinaText = $thisButton.data( 'text' ),
            characters = buttonNinaText.split(""),
            transitionDelay = 0;

        $.each(characters, function (i, el) {

            if ( el === " " ){
                el = '&nbsp;';
            }
            
            $thisButton.append( '<span style="transition-delay:' + (transitionDelay+=.035) + 's;">' + el + '</span>' );
        });
    });

    // Rayen button style
    $( '.btn-rayen').each( function() {

        let $buttonRayenText = $( this ).data( 'text' );

        $( this ).append( '<span>' + $buttonRayenText + '</span>' );
    });
});